import { render, staticRenderFns } from "./TaskAssignment.vue?vue&type=template&id=36214808&scoped=true"
import script from "./TaskAssignment.vue?vue&type=script&lang=js"
export * from "./TaskAssignment.vue?vue&type=script&lang=js"
import style0 from "./TaskAssignment.vue?vue&type=style&index=0&id=36214808&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36214808",
  null
  
)

export default component.exports